import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Offcanvas, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { commonService } from "../../../../utils/commonService";
import { MultiSelect } from "primereact/multiselect";

const AccountFilter = ({ showModal, closeModal, filterData, updatePayload }) => {
    const startRangeDateRef = useRef();
    const endRangeDateRef = useRef();
    const [filter, setFilter] = useState(filterData);
    const [startRangeDate, setStartRangeDate] = useState();
    const [endRangeDate, setEndRangeDate] = useState();

    const handleDateChange = (event) => {
        const [start, end] = event;
        let startSelectedDate = "",
            endSelectedDate = "";
        if (start) {
            let date = new Date(start);
            let month =
                date.getMonth() + 1 > 9
                    ? date.getMonth() + 1
                    : `0${date.getMonth() + 1}`;
            let dateFormat =
                date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
            startSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
            startRangeDateRef.current = startSelectedDate;
        }
        if (end) {
            let date = new Date(end);
            let month =
                date.getMonth() + 1 > 9
                    ? date.getMonth() + 1
                    : `0${date.getMonth() + 1}`;
            let dateFormat =
                date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
            endSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
            endRangeDateRef.current = endSelectedDate;
        }

        setStartRangeDate(event[0]);
        setEndRangeDate(event[1]);
    };

    useEffect(() => {
        setFilter(filterData);
        setStartRangeDate(filterData?.stayDateStart);
        setEndRangeDate(filterData?.stayDateEnd);
    }, [filterData]);

   
    return (
        <Offcanvas
            className="notification-canvas"
            show={showModal}
            onHide={closeModal}
            placement="end"
            data-bs-focus="false"
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                    <Button id={commonService.generateGlobalClickTrackerID("AccountFilter", "apply", "")}
                        className="default-btn primary-btn"
                        onClick={() => {
                            if (startRangeDate && endRangeDate) {
                                filter.stayDateStart = startRangeDate;
                                filter.stayDateEnd = endRangeDate;
                            }
                            updatePayload(filter);
                            closeModal();
                        }}
                    >
                        Apply
                    </Button>
                </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body id="canvas">
                <Row>
                    <Col xl={6}>
                        <div className="startFrom from-groups no-border-break">
                            <Form.Label htmlFor="startFrom">
                                Reservation OTB as of
                            </Form.Label>
                            <DatePicker
                                portalId="datepicker-root"
                                id="asOfDateLeft"
                                selected={
                                    filter?.asOfDate
                                        ? commonService.convertDateInTimezone(filter?.asOfDate)
                                        : ""
                                }
                                onChange={(date) => {
                                    setFilter({
                                        ...filter,
                                        asOfDate: date,
                                    });
                                }}
                            />
                        </div>
                    </Col>

                    <Col xl={6}>
                        <div className="startFrom from-groups no-border-break">
                            <Form.Label htmlFor="startFrom">Stay Date</Form.Label>
                            <DatePicker id={commonService.generateGlobalClickTrackerID("AccountFilter", "stay-date", "")}
                                portalId="datepicker-root"
                                onChange={handleDateChange}
                                startDate={startRangeDate ? new Date(startRangeDate) : ""}
                                endDate={endRangeDate ? new Date(endRangeDate) : ""}
                                selectsRange
                                monthsShown={2}
                            />
                        </div>
                    </Col>

                    {/* ===== Source ===== */}
                    <Col xl={6} className="mt-3">
                        <div>
                            <p>Source</p>
                            <MultiSelect id={commonService.generateGlobalClickTrackerID("AccountFilter", "multiselect-onchange", "")}
                                value={Object.keys(filter.channel).filter(
                                    (key) => filter.channel[key]
                                )}
                                options={Object.keys(filter.channel).map((key) => ({
                                    label: key,
                                    value: key,
                                }))}
                                onChange={(e) => {
                                    const selectedValues = e.value;
                                    const updatedChannel = Object.keys(filter.channel).reduce(
                                        (acc, key) => {
                                            acc[key] = selectedValues.includes(key);
                                            return acc;
                                        },
                                        {}
                                    );
                                    setFilter({
                                        ...filter,
                                        channel: updatedChannel,
                                    });
                                }}
                                filter
                                placeholder="Select Source"
                                display="values"
                                selectedItemsLabel="{0} items selected"
                                maxSelectedLabels={0}
                                closeOnSelect={false}
                                appendTo="self"

                            />
                        </div>
                    </Col>

                    {/* ===== Company ===== */}
                    <Col xl={6} className="mt-3">
                        <div>
                            <p>Company</p>
                            <MultiSelect id={commonService.generateGlobalClickTrackerID("AccountFilter", "multiselect-onchange", "")}
                                value={Object.keys(filter?.company).filter(
                                    (key) => filter.company[key]
                                )}
                                options={Object.keys(filter.company).map((key) => ({
                                    label: key,
                                    value: key,
                                }))}
                                onChange={(e) => {
                                    const selectedValues = e.value;
                                    const updatedCompany = Object.keys(filter.company).reduce(
                                        (acc, key) => {
                                            acc[key] = selectedValues.includes(key);
                                            return acc;
                                        },
                                        {}
                                    );
                                    setFilter({
                                        ...filter,
                                        company: updatedCompany,
                                    });
                                }}
                                filter
                                placeholder="Select Company"
                                display="values"
                                selectedItemsLabel="{0} items selected"
                                maxSelectedLabels={0}
                                closeOnSelect={false}
                                appendTo="self"
                            />
                        </div>
                    </Col>

                    {/* ===== Market Segment ===== */}
                    <Col xl={6} className="mt-3">
                        <div>
                            <p>Market Segment</p>
                            <MultiSelect id={commonService.generateGlobalClickTrackerID("AccountFilter", "multiselect-onchange", "")}
                                value={Object.keys(filter?.marketSegment).filter(
                                    (key) => filter.marketSegment[key]
                                )}
                                options={Object.keys(filter.marketSegment).map((key) => ({
                                    label: key,
                                    value: key,
                                }))}
                                onChange={(e) => {
                                    const selectedValues = e.value;
                                    const updatedMarketSegment = Object.keys(
                                        filter.marketSegment
                                    ).reduce((acc, key) => {
                                        acc[key] = selectedValues.includes(key);
                                        return acc;
                                    }, {});
                                    setFilter({
                                        ...filter,
                                        marketSegment: updatedMarketSegment,
                                    });
                                }}
                                filter
                                placeholder="Select Market Segment"
                                display="values"
                                selectedItemsLabel="{0} items selected"
                                maxSelectedLabels={0}
                                closeOnSelect={false}
                                appendTo="self"
                            />
                        </div>
                    </Col>

                    {/* ===== Rate Code ===== */}
                    <Col xl={6} className="mt-3">
                        <div>
                            <p>Rate Code</p>
                            <MultiSelect id={commonService.generateGlobalClickTrackerID("AccountFilter", "multiselect-onchange", "")}
                                value={Object.keys(filter?.rateCode).filter(
                                    (key) => filter.rateCode[key]
                                )}
                                options={Object.keys(filter.rateCode).map((key) => ({
                                    label: key,
                                    value: key,
                                }))}
                                onChange={(e) => {
                                    const selectedValues = e.value;
                                    const updatedRateCode = Object.keys(
                                        filter.rateCode
                                    ).reduce((acc, key) => {
                                        acc[key] = selectedValues.includes(key);
                                        return acc;
                                    }, {});
                                    setFilter({
                                        ...filter,
                                        rateCode: updatedRateCode,
                                    });
                                }}
                                filter
                                placeholder="Select Rate Code"
                                display="values"
                                selectedItemsLabel="{0} items selected"
                                maxSelectedLabels={0}
                                closeOnSelect={false}
                                appendTo="self"
                            />
                        </div>
                    </Col>

                    {/* ===== Rate Code Description ===== */}
                    <Col xl={6} className="mt-3">
                        <div>
                            <p>Rate Code Description</p>
                            <MultiSelect id={commonService.generateGlobalClickTrackerID("AccountFilter", "multiselect-onchange", "")}
                                value={Object.keys(filter?.rateCodeDescription).filter(
                                    (key) => filter.rateCodeDescription[key]
                                )}
                                options={Object.keys(filter.rateCodeDescription).map(
                                    (key) => ({
                                        label: key,
                                        value: key,
                                    })
                                )}
                                onChange={(e) => {
                                    const selectedValues = e.value;
                                    const updatedRateCodeDesc = Object.keys(
                                        filter.rateCodeDescription
                                    ).reduce((acc, key) => {
                                        acc[key] = selectedValues.includes(key);
                                        return acc;
                                    }, {});
                                    setFilter({
                                        ...filter,
                                        rateCodeDescription: updatedRateCodeDesc,
                                    });
                                }}
                                filter
                                placeholder="Select Rate Code Description"
                                display="values"
                                selectedItemsLabel="{0} items selected"
                                maxSelectedLabels={0}
                                closeOnSelect={false}
                                appendTo="self"
                            />
                        </div>
                    </Col>

                    {/* ===== Occ Threshold ===== */}
                    <Col xl={6} className="mt-3">
                        <div>
                            <p>Occ Threshold</p>
                            <Form.Control id={commonService.generateGlobalClickTrackerID("AccountFilter", "form-control-onchange", "")}
                                type="number"
                                value={filter?.occ_threshold}
                                onChange={(e) =>
                                    setFilter({
                                        ...filter,
                                        occ_threshold: e.target.value,
                                    })
                                }
                            />
                        </div>
                    </Col>

                    {/* ===== Lead Time ===== */}
                    <Col xl={6} className="mt-3">
                        <div>
                            <p>Lead Time</p>
                            <Row>
                                <Col xl={6}>
                                    <Form.Select id={commonService.generateGlobalClickTrackerID("AccountFilter", "form-select-onchange", "")}
                                        value={filter?.leadTimeOperator}
                                        onChange={(e) =>
                                            setFilter({
                                                ...filter,
                                                leadTimeOperator: e.target.value,
                                            })
                                        }
                                    >
                                        <option value=">=">{">="}</option>
                                        <option value="<=">{"<="}</option>
                                        <option value="=">{"="}</option>
                                    </Form.Select>
                                </Col>
                                <Col xl={6}>
                                    <Form.Control id={commonService.generateGlobalClickTrackerID("AccountFilter", "form-control-onchange", "")}
                                        type="text"
                                        value={filter?.leadTime}
                                        onChange={(e) =>
                                            setFilter({
                                                ...filter,
                                                leadTime: e.target.value,
                                            })
                                        }
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Col>

                    {/* ===== LOS ===== */}
                    <Col xl={6} className="mt-3">
                        <div>
                            <p>LOS</p>
                            <Row>
                                <Col xl={6}>
                                    <Form.Select id={commonService.generateGlobalClickTrackerID("AccountFilter", "form-select-onchange", "")}
                                        value={filter?.losOperator}
                                        onChange={(e) =>
                                            setFilter({
                                                ...filter,
                                                losOperator: e.target.value,
                                            })
                                        }
                                    >
                                        <option value=">=">{">="}</option>
                                        <option value="<=">{"<="}</option>
                                        <option value="=">{"="}</option>
                                    </Form.Select>
                                </Col>
                                <Col xl={6}>
                                    <Form.Control id={commonService.generateGlobalClickTrackerID("AccountFilter", "form-control-onchange", "")}
                                        type="text"
                                        value={filter?.los}
                                        onChange={(e) =>
                                            setFilter({
                                                ...filter,
                                                los: e.target.value,
                                            })
                                        }
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default AccountFilter;
